import React from 'react';
import PrimaryButton from '../../ui/PrimaryButton';
import TextButton from '../../ui/TextButton';
import FormSection from '../../ui/form/FormSection';
import RadioGroup, {Option} from '../../ui/RadioGroup';
import {Maybe} from '../../schema';

type FormProps = {
  backLink: string;
  renewalPeriod?: Maybe<number>
  onSubmit?: (period: number) => void;
}

export default function RenewalPeriodForm({backLink, renewalPeriod, onSubmit}: FormProps) {
  const [selected, setSelected] = React.useState<number>(renewalPeriod || 0);

  const onFormSubmit = () => {
    if (onSubmit) {
      onSubmit(selected);
    }
  };
  const options: Option[] = [5, 10, 15, 30, 45, 0].map((value) => {
    return {
      id: value.toString(),
      value: value === 0 ? 'Unlimited' : `${value} days`
    }
  });

  return (
    <>
      <div className={'mb-5'}>
        <FormSection>
          <RadioGroup options={options} selectedValue={(renewalPeriod || 0).toString()} className="mb-4"
                      onChange={(value) => setSelected(parseInt(value, 10))}/>
          <div className="pt-6 flex flex-row justify-between">
            <div className="flex flex-row justify-start">
              <PrimaryButton className="w-32 mr-6" onClick={onFormSubmit}>Save</PrimaryButton>
              <TextButton onClick={() => window.location.assign(backLink)}>Cancel changes</TextButton>
            </div>
          </div>
        </FormSection>
      </div>
    </>
  );
}
